import MemberPopup from './member-popup';

const $ = jQuery.noConflict();
import '@fancyapps/fancybox';

'use strict';
const Fancybox = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */


	/** @description Initialize */
	init: function() {
		this.fancyboxPopup('.js-popup-trigger', '.js-popup', 'popup-custom-class');
		this.fancyboxPopup('.js-site-header__top-right-link', '.js-site-header__login-popup', 'site-header__login-popup-custom');
		this.fancyboxPopup('.js-site-header__top-search-link', '.js-site-header__top-search', 'site-header__login-popup-custom');
		this.fancyboxPopup('.js-hero__link-target', '.js-hero__video-popup');
		this.fancyboxPopup('.js-new-hero__link-target', '.js-new-hero__video-popup');
		this.fancyboxPopup('.js-half-block-popup-trigger', '.js-half-block__video-popup');
		this.fancyboxPopup('.js-how-it-works__link-target', '.js-how-it-works__video-popup');
		this.fancyboxPopup('.js-popup-register-form', '.js-popup-register');
		this.fancyboxPopup('.js-small-block-popup-trigger', '.js-small-block__video-popup');
		this.fancyboxPopup('.js-popup-message-form', '.js-popup-message');
		this.fancyboxPopup('.js-vegetable-guide__popup-trigger', '.js-insects-popup');
		this.fancyboxPopup('.js-vegetable-card-popup-trigger', '.js-vegetable-card-popup');
		/* this.fancyboxPopup('.js-steps__link-target', '.js-steps__video-popup'); */
		this.fancyboxPopup('.js-popup-issue', '.js-popup-spirit-issue');
		this.fancyboxPopup('.js-issue-popup', '.js-popup-spirit-issue');

		$('.js-steps__link-target').each((i, el) => {
			const popup = $(el).next();
			Fancybox.fancyboxPopup(el, popup);
		});
	},

	/**
	 * @description Fancy box custom popup functionality.
	 * @link documentation https://fancyapps.com/fancybox/3/docs/#inline
	 * @example this.functions.fancyboxPopup('.popup-btn', '.popup', 'my-custom-class');
	 * @param {string} trigger - popup trigger
	 * @param {string} popup - popup wrapper class
	 * @param {string} customClass - custom class for each popup (optional)
	 */
	fancyboxPopup: (trigger, popup, customClass = '') => {
		$(trigger).fancybox({
			src: popup,
			type: 'inline',
			smallBtn: true,
			baseClass: customClass,
			touch: false,
			afterShow: function() {
				const iframe = $(popup).find('iframe');
				const videoSrc = iframe.data('src');
				if (iframe && videoSrc) {
					iframe.attr('src', videoSrc);
				}
			},
			afterClose: function() {
				if ($('.js-kosher-spirit-page').length > 0) {
					window.history.pushState('', '', MemberPopup.$domUrl);
				}
			}
		});
	}
};

export default Fancybox;
